import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Typography, Box } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import get from 'lodash/get';

import Card from '../components/Card';

const barColors = [
  'linear-gradient(to left, #f4cccc, #fbeaea)',
  'linear-gradient(to left, #c9c9f8, #ececff)',
  'linear-gradient(to left, #ffd9b3, #fff0e6)',
  'linear-gradient(to left, #b3c6ff, #e6ecff)',
  'linear-gradient(to left, #d1f7c4, #f0fff0)',
];

const ThreatCategory = () => {
  const data = useSelector((state) => get(state.ecosystems.ecosystem, 'threat.threat_category', []) || []);

  const isLoading = useSelector((state) => get(state.ecosystems.ecosystem.loading, 'threat.threat_category', false));

  const maxValue = useMemo(() => Math.max(...data.map((item) => item.Total), 0), [data]);

  return (
    <Card icon={AppsIcon} isLoading={isLoading} title="Threat By Categories">
      <Box sx={{ width: '100%', py: 3, px: 2.5, rowGap: 2 }}>
        {data.map((item, index) => {
          const name = item.Attributes?.threat_category || 'Unknown';
          const value = item.Total;
          const barWidth = `${(value / maxValue) * 100}%`;
          const color = barColors[index % barColors.length];
          return (
            <Box
              key={`${name}-${index}`}
              sx={{
                background: color,
                width: barWidth,
                px: 2,
                py: 0.5,
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: 12, lineHeight: '28px' }}
                data-test-id={`threat-category-${name}`}
              >
                {name}&nbsp;
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: 12, lineHeight: '28px' }}
                data-test-id={`threat-category-value-${name}`}
              >
                {value}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Card>
  );
};

export default ThreatCategory;
